$company-logos-gap: 2rem;
$company-logos-gap-carousel: 4rem;

.company-logos-type-1__list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: $company-logos-gap;
  white-space: nowrap;
  justify-content: center;
}

.company-logos-type-1__list--animated {
  width: max-content;
  animation: 60s slide infinite linear;
}

.company-logos-type-1__list-item {
  width: 140px;
  min-width: 140px;
  text-align: center;
}

.company-logos-type-1__list-item img {
  width: 100%;
  height: auto;
}

.company-logos-type-1__text-centered {
  text-align: center;
}

.company-logos-type-1--carousel {
  overflow-x: hidden;
}

.company-logos-type-1--carousel .company-logos-type-1__list {
  flex-wrap: nowrap;
  gap: $company-logos-gap-carousel;
  scroll-behavior: smooth;
  scrollbar-width: none;
  white-space: nowrap;
}

@keyframes slide {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(calc(-100% / var(--logos-repeat-count, 2)));
  }
}
